var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleTable',{attrs:{"formclass":"Partner/form","endpoint":"partners","aditionalColumns":_vm.headers,"inlineToggle":""},scopedSlots:_vm._u([{key:"extra-column",fn:function(item){return [_vm._v(" "+_vm._s(item.discount)+" % ")]}}])},[[_c('h1',[_vm._v("Cadastro de Convênios")]),_c('v-divider',{staticClass:"mb-4"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }